import DefaultInputField from "../shared/fields/DefaultInputField";
import MultiSelectField from "./fields/MultiSelectField";
import ProfileAgency from "./fields/ProfileAgency";

export const PROFILE_OPTIONS = [
  { value: "departmentAgencies", label: "Agency", initialValue: [] },
  { value: "naicsCodes", label: "NAICS Codes", initialValue: "" },
  { value: "contractTypes", label: "Notice Types", initialValue: [] },
  { value: "setAsides", label: "Set Aside", initialValue: [] },
  { value: "classificationCodes", label: "PSC Codes", initialValue: "" },
  { value: "subTiers", label: "Sub-tier", initialValue: "" },
  { value: "offices", label: "Office", initialValue: "" },
  {
    value: "placeOfPerformance",
    label: "Place of Performance",
    initialValue: "",
  },
  { value: "officeLocation", label: "Office Location", initialValue: "" },
];

export const PREFERRED_CONTRACT_TYPES = [
  { value: "Award Notice", label: "Award Notice" },
  {
    value: "Combined Synopsis/Solicitation",
    label: "Combined Synopsis/Solicitation",
  },
  {
    value: "Consolidate/(Substantially) Bundle",
    label: "Consolidate/(Substantially) Bundle",
  },
  { value: "Justification", label: "Justification" },
  {
    value: "Justification and Approval (J&A)",
    label: "Justification and Approval (J&A)",
  },
  {
    value: "Modification/Amendment/Cancel",
    label: "Modification/Amendment/Cancel",
  },
  { value: "Presolicitation", label: "Presolicitation" },
  { value: "Sale of Surplus Property", label: "Sale of Surplus Property" },
  { value: "Solicitation", label: "Solicitation" },
  { value: "Sources Sought", label: "Sources Sought" },
  { value: "Special Notice", label: "Special Notice" },
];

export const FIELD_LIST = [
  { component: ProfileAgency },
  {
    component: DefaultInputField,
    props: {
      fieldId: "naicsCodes",
      label: "NAICS Codes (comma separated)",
      placeholder: "e.g. 541511, 541512",
    },
  },
  {
    component: MultiSelectField,
    props: {
      labelText: "Notice Types",
      fieldId: "contractTypes",
      options: PREFERRED_CONTRACT_TYPES,
    },
  },
  {
    component: MultiSelectField,
    props: {
      labelText: "Set Aside",
      fieldId: "setAsides",
      optionsSource: "setAsides",
    },
  },
  {
    component: DefaultInputField,
    props: {
      fieldId: "classificationCodes",
      label: "PSC Codes (comma separated)",
      placeholder: "e.g. R425, D301",
    },
  },
  {
    component: DefaultInputField,
    props: {
      fieldId: "subTiers",
      label: "Sub-tier (comma separated)",
      placeholder: "Sub-tier",
    },
  },
  {
    component: DefaultInputField,
    props: {
      fieldId: "offices",
      label: "Office (comma separated)",
      placeholder: "Office",
    },
  },
  {
    component: DefaultInputField,
    props: {
      fieldId: "placeOfPerformance",
      label: "Place of Performance",
      placeholder: "Place of Performance",
    },
  },
  {
    component: DefaultInputField,
    props: {
      fieldId: "officeLocation",
      label: "Office Location",
      placeholder: "Office Location",
    },
  },
];
